import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse, Form, Input, notification } from "antd";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import Link from "next/link";
const Call = require("../../Assets/Images/Icons/Call.svg");
const Facebook = require("../../Assets/Images/Icons/Facebook.svg");
const Inlinked = require("../../Assets/Images/Icons/Inlinked.svg");
const Location = require("../../Assets/Images/Icons/Location.svg");
const Logo = require("../../Assets/Images/Icons/Logo_white.svg");
const Message = require("../../Assets/Images/Icons/Message-blue.svg");
const MessageGray = require("../../Assets/Images/Icons/Message_outline_gray.svg");
const arrw = require("../../Assets/Images/Icons/arrw.svg");
const Ytb = require("../../Assets/Images/Icons/ytb.svg");
const styles = require("./Footer.module.scss");
import duns from "@/src/Assets/Images/Chat/DRSwdisclaimer 1.png";

type NotificationType = "success";

export const FooterPresenter = () => {
  const { Panel } = Collapse;
  const { t } = useTranslation(["translation"]);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type: NotificationType) => {
    api[type]({
      message: t("SUCCESS"),
      description: t("SUCCESS_DES"),
    });
  };
  const onFinish = (values: any) => {
    openNotificationWithIcon("success");
  };
  return (
    <>
      {contextHolder}
      <div className={styles.footer}>
        <div className={styles.footer__container}>
          <div className={styles.footer__container__list}>
            <div className={styles.footer__container__list__item}>
              <Image src={Logo} alt="" loading="lazy" />
              <div className={styles.footer__container__list__item__content}>
                <p>{t("ET_HAS_MANY")}</p>
              </div>
              <div className={styles.footer__container__list__item__location}>
                <Image src={Location} alt="" loading="lazy" />
                <span>{t("268_THD")}</span>
              </div>
              <div className={styles.footer__container__list__item__location}>
                <Image src={Call} alt="" loading="lazy" />
                <span>{`+84 28 7300 1811`}</span>
              </div>
              <div className={styles.footer__container__list__item__location}>
                <Image src={Message} alt="" loading="lazy" />
                <span>{`info@exceltech.vn`}</span>
              </div>
              <div
                className={styles.footer__container__list__item__location__mb}
              >
                <Link
                  href="https://www.facebook.com/exceltech.vn"
                  prefetch={false}
                >
                  <Image src={Facebook} alt="" style={{ cursor: "pointer" }} />
                </Link>
                <Link
                  href="https://www.linkedin.com/company/excel-technology"
                  prefetch={false}
                >
                  <Image src={Inlinked} alt="" style={{ cursor: "pointer" }} />
                </Link>
                <Link
                  href="https://www.youtube.com/@exceltechnologies7190/featured"
                  prefetch={false}
                >
                  <Image src={Ytb} alt="" style={{ cursor: "pointer" }} />
                </Link>
              </div>
            </div>
            <div className={styles.footer__container__list__info}>
              <div className={styles.footer__container__list__info__item}>
                <h3>{t("ABOUT")} </h3>
                <Link href="/our-product" prefetch={false}>
                  {t("OUR_COMPANY")}
                </Link>
                <Link href="/our-team" prefetch={false}>
                  {t("OUR_TEAM")}
                </Link>
                <Link href="/career" prefetch={false}>
                  {t("CAREER")}
                </Link>
                <Link href="/contact-us" prefetch={false}>
                  {t("CONTACT_US")}
                </Link>
              </div>
              <div className={styles.footer__container__list__info__item}>
                <h3>{t("OUR_SERVICES")}</h3>
                <Link
                  href="/service-engineering"
                  prefetch={false}
                >{`Engineering`}</Link>
                <Link
                  href="/service-platform"
                  prefetch={false}
                >{`Platforms`}</Link>
                <Link
                  href="/service-solution"
                  prefetch={false}
                >{`Solutions`}</Link>
                <Link href="/service-cloud" prefetch={false}>{`Clouds`}</Link>
              </div>
              <div className={styles.footer__container__list__info__item}>
                <h3>{t("JOIN_OUR_MEMBER")}</h3>
                <Form onFinish={onFinish}>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: t("PL_EMAIL") || "",
                      },
                    ]}
                  >
                    <Input
                      className={styles.footer__container__list__item__input}
                      prefix={<Image src={MessageGray} alt="" />}
                      placeholder={t("ENTER_YOUR_MAIL") as any}
                    />
                  </Form.Item>
                  <button type="submit" className="button-color2 box-sha">
                    {t("SUBMIT")}
                    <Image src={arrw} alt="" />
                  </button>
                </Form>
              </div>
            </div>
            <div className={styles.footer__container__list__Mb}>
              <Collapse
                bordered={false}
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined
                    rotate={isActive ? 90 : 0}
                    rev={undefined}
                  />
                )}
                className={styles.footer__container__list__Mb__collapse}
              >
                <Panel
                  header={t("ABOUT")}
                  key="1"
                  className={styles.footer__container__list__Mb__title}
                  style={{ marginBottom: "20px" }}
                >
                  <Link href="/our-product" prefetch={false}>
                    {t("OUR_COMPANY")}
                  </Link>
                  <Link href="/our-team" prefetch={false}>
                    {t("OUR_TEAM")}
                  </Link>
                  <Link href="/career" prefetch={false}>
                    {t("CAREER")}
                  </Link>
                  <Link href="/contact-us" prefetch={false}>
                    {t("CONTACT_US")}
                  </Link>
                </Panel>
                <Panel
                  header={t("OUR_SERVICES")}
                  key="2"
                  className={styles.footer__container__list__Mb__title}
                  style={{ marginBottom: "20px" }}
                >
                  <Link
                    href="/service-engineering"
                    prefetch={false}
                  >{`Engineering`}</Link>
                  <Link
                    href="/service-platform"
                    prefetch={false}
                  >{`Platforms`}</Link>
                  <Link
                    href="/service-solution"
                    prefetch={false}
                  >{`Solutions`}</Link>
                  <Link href="/service-cloud" prefetch={false}>{`Clouds`}</Link>
                </Panel>
                <Panel
                  header={t("JOIN_OUR_MEMBER")}
                  key="3"
                  className={styles.footer__container__list__Mb__title}
                >
                  <Form onFinish={onFinish}>
                    <p>
                      <Input
                        className={styles.footer__container__list__item__input}
                        prefix={<Image src={MessageGray} alt="" />}
                        placeholder={t("ENTER_YOUR_MAIL") as any}
                      />
                      <button>
                        {t("SUBMIT")} <span>{`⟶`}</span>
                      </button>
                    </p>
                    <p></p>
                  </Form>
                </Panel>
              </Collapse>
            </div>
          </div>
          <div className={styles.footer__container__listFoot}>
            <div className={styles.footer__container__listFoot__info}>
              <Link
                href="https://www.facebook.com/exceltech.vn"
                prefetch={false}
              >
                <Image
                  src={Facebook}
                  alt=""
                  style={{ cursor: "pointer" }}
                  loading="lazy"
                />
              </Link>
              <Link
                href="https://www.linkedin.com/company/excel-technology"
                prefetch={false}
              >
                <Image
                  src={Inlinked}
                  alt=""
                  style={{ cursor: "pointer" }}
                  loading="lazy"
                />
              </Link>
              <Link
                href="https://www.youtube.com/@exceltechnologies7190/featured"
                prefetch={false}
              >
                <Image
                  src={Ytb}
                  alt=""
                  style={{ cursor: "pointer" }}
                  loading="lazy"
                />
              </Link>
            </div>
            <div className={styles.footer__container__listFoot__coppyRight}>
              <p className="unhideFooter">
                © 2023 Excel Technologies. All rights reserved
              </p>
              <p className="hideFooter">
                © 2023 Excel Technologies.
                <br />
                All rights reserved
              </p>
              <p className={styles.footer__container__listFoot__coppyRight__policy}>
                <Link href="/privacy-policy" prefetch={false}>
                  {t("PRIVACY_POLICY")}
                </Link>
              </p>
              <div
                className={styles.footer__container__listFoot__coppyRight__duns}
              >
                <a href="https://dunsregistered.com/">
                  <Image src={duns} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FooterPresenter;
